import axios from "axios";
// import qs from "qs";
// let siteList = [
//     {name: '徐汇通', id: '310104', downUrl: 'https://www.shmedia.tech/xhapp/', logo: 'https://assets.shmedia.tech/icon/xh.jpg', url: 'xhweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/xh.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1462875484?mt=8', anUrl: 'https://www.shmedia.tech/apk/xh.apk'},
//     {name: '上海杨浦', id: '310110', downUrl: 'https://www.shmedia.tech/ypapp/', logo: 'https://assets.shmedia.tech/icon/yp.png', url: 'ypweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/yp.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465447632?mt=8', anUrl: 'https://www.shmedia.tech/apk/yp.apk'},
//     {name: '怡动', id: '310000', downUrl: '', logo: '', url: 'wdit-gateway.shmedia.tech'},
//     {name: '松江', id: '310117', downUrl: '', logo: '', url: 'songjiang-gateway.shmedia.tech'},
//     {name: '上海嘉定', id: '310114', downUrl: 'https://www.shmedia.tech/jdapp/', logo: 'https://assets.shmedia.tech/icon/jd.png', url: 'jdweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/jd.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465445680?mt=8', anUrl: 'https://www.shmedia.tech/apk/jd.apk'},
//     {name: '绿色青浦', id: '310118', downUrl: 'https://www.shmedia.tech/qpapp/', logo: 'https://assets.shmedia.tech/icon/qp.png', url: 'qpweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/qp.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1469767891?mt=8', anUrl: 'https://www.shmedia.tech/apk/qp.apk'},
//     {name: '上海虹口', id: '310109', downUrl: 'https://www.shmedia.tech/hkapp/', logo: 'https://assets.shmedia.tech/icon/hk.png', url: 'hkweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/hk.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465446765?mt=8', anUrl: 'https://www.shmedia.tech/apk/hk.apk'},
//     {name: '黄埔', id: '310101', downUrl: '', logo: '', url: 'huangpu-gateway.shmedia.tech'},
//     {name: '上海长宁', id: '310105', downUrl: 'https://www.shmedia.tech/cnapp/', logo: 'https://assets.shmedia.tech/icon/cn.png', url: 'cnweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/cn.png', iosUrl: 'https://apps.apple.com/cn/app/%E9%95%BF%E5%AE%81%E6%96%B0%E9%97%BB/id1329895656', anUrl: 'https://www.shmedia.tech/apk/cn.apk'},
//     {name: '美谷奉贤', id: '310120', downUrl: 'https://www.shmedia.tech/fxapp/', logo: 'https://assets.shmedia.tech/icon/fx.png', url: 'fxweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/fx.png', iosUrl: 'https://apps.apple.com/cn/app/zi-wei-dai/id1469767823', anUrl: 'https://www.shmedia.tech/apk/fx.apk'},
//     {name: '上海普陀', id: '310107', downUrl: 'https://www.shmedia.tech/ptapp/', logo: 'https://assets.shmedia.tech/icon/pt.png', url: 'ptweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/pt.png', iosUrl: 'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E6%99%AE%E9%99%80/id1439034227', anUrl: 'https://www.shmedia.tech/apk/pt.apk'},
//     {name: '浦东', id: '310115', downUrl: '', logo: '', url: 'pudong-gateway.shmedia.tech'},
//     {name: '今日闵行', id: '310112', downUrl: '', url: 'minhang-gateway.shmedia.tech', logo: './icon/minhang.png', background: './backimg/shareBackgroud.png', iosUrl: 'https://apps.apple.com/cn/app/%E4%BB%8A%E6%97%A5%E9%97%B5%E8%A1%8C/id1476809729?appdownload', anUrl:'https://www.shmedia.tech/apk/mh.apk?appdownload'},
//     {name: '上海静安', id: '310106', downUrl: 'https://www.shmedia.tech/jaapp/', logo: 'https://assets.shmedia.tech/icon/ja.png', url: 'jaweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/ja.jpg', iosUrl: 'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E9%9D%99%E5%AE%89/id859137971', anUrl:'https://www.shmedia.tech/apk/ja.apk'},
//     {name: '宝山汇', id: '310113', downUrl: 'https://www.shmedia.tech/bsapp/', logo: 'https://assets.shmedia.tech/icon/bs.png', url: 'bsweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/bs.png', iosUrl: 'https://apps.apple.com/cn/app/%E5%AE%9D%E5%B1%B1%E6%B1%87/id1476961748', anUrl:'https://www.shmedia.tech/apk/bs.apk'},
//     {name: '上海黄浦', id: '310101', downUrl: 'https://www.shmedia.tech/hpapp/', logo: 'https://assets.shmedia.tech/icon/hp.png', url: 'hpweb.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/hp.png', iosUrl: 'https://apps.apple.com/cn/app/%E9%98%BF%E6%8B%89%E9%BB%84%E6%B5%A6/id1457540658', anUrl: 'https://www.shmedia.tech/apk/hp.apk'},
    
    
//     {name: '金山', id: '310116', downUrl: '', logo: '', url: 'jinshan-gateway.shmedia.tech'},
//     {name: '不容易', id: '100000', downUrl: 'https://www.shmedia.tech/yysc/', logo: 'https://assets.shmedia.tech/icon/burongyi.png', url: 'bry', background: 'https://assets.shmedia.tech/share/backgroundImages/shareBackgroud.png', iosUrl: '', anUrl: ''},
//     {name: '遂溪', id: '440823', downUrl: '', logo: '', url: 'suixi-gateway.shmedia.tech'},
//     {name: '徐闻', id: '440825', downUrl: '', logo: '', url: 'xuwen-gateway.shmedia.tech'},
//     {name: '雷州', id: '440882', downUrl: '', logo: '', url: 'leizhou-gateway.shmedia.tech'},
//     {name: '信宜', id: '440983', downUrl: '', logo: '', url: 'xinyi-gateway.shmedia.tech'},
//     {name: '阳西', id: '441721', downUrl: '', logo: '', url: 'yangxi-gateway.shmedia.tech'},

//     {name: '今日城区', id: '441500', downUrl: '', url: 'https://swweb.gdmedia.tech', 
//     logo: 'https://swweb.gdmedia.tech/h5/sw/share/backimg/jrcq.jpg', background: './backimg/shareBackgroud.png',
//     iosUrl: 'https://apps.apple.com/cn/app/id1564689567', 
//     anUrl:'https://appgallery.huawei.com/app/C104261407'},

 
// ]
let siteList = [
    {name: '徐汇通', id: '310104', downUrl: 'https://www.shmedia.tech/xhapp/', logo: 'https://assets.shmedia.tech/icon/xh.jpg', url: 'xuhui-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/xh.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1462875484?mt=8', anUrl: 'https://www.shmedia.tech/apk/xh.apk'},
    
    {name: '上海杨浦', id: '310110', downUrl: 'https://www.shmedia.tech/ypapp/', logo: 'https://assets.shmedia.tech/icon/yp.png', url: 'yangpu-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/yp.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465447632?mt=8', anUrl: 'https://www.shmedia.tech/apk/yp.apk'},
    
    {name: '怡动', id: '310000', downUrl: '', logo: '', url: 'wdit-gateway.shmedia.tech'},
    
    {name: '松江', id: '310117', downUrl: '', logo: '', url: 'songjiang-gateway.shmedia.tech'},
   
    {name: '上海嘉定', id: '310114', downUrl: 'https://www.shmedia.tech/jdapp/', logo: 'https://assets.shmedia.tech/icon/jd.png', url: 'jiading-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/jd.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465445680?mt=8', anUrl: 'https://www.shmedia.tech/apk/jd.apk'},
   
    {name: '绿色青浦', id: '310118', downUrl: 'https://www.shmedia.tech/qpapp/', logo: 'https://assets.shmedia.tech/icon/qp.png', url: 'qingpu-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/qp.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1469767891?mt=8', anUrl: 'https://www.shmedia.tech/apk/qp.apk'},
   
    {name: '上海虹口', id: '310109', downUrl: 'https://www.shmedia.tech/hkapp/', logo: 'https://assets.shmedia.tech/icon/hk.png', url: 'hongkou-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/hk.png', iosUrl: 'https://itunes.apple.com/cn/app/zi-wei-dai/id1465446765?mt=8', anUrl: 'https://www.shmedia.tech/apk/hk.apk'},
   
    {name: '上海黄浦', id: '310101', downUrl: 'https://www.shmedia.tech/hpapp/', logo: 'https://assets.shmedia.tech/icon/hp.png', url: 'huangpu-gateway.shmedia.tech'},
   
    {name: '上海长宁', id: '310105', downUrl: 'https://www.shmedia.tech/cnapp/', logo: 'https://assets.shmedia.tech/icon/cn.png', url: 'changning-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/cn.png', iosUrl: 'https://apps.apple.com/cn/app/%E9%95%BF%E5%AE%81%E6%96%B0%E9%97%BB/id1329895656', anUrl: 'https://www.shmedia.tech/apk/cn.apk'},
    
    {name: '美谷奉贤', id: '310120', downUrl: 'https://www.shmedia.tech/fxapp/', logo: 'https://assets.shmedia.tech/icon/fx.png', url: 'fengxian-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/fx.png', iosUrl: 'https://apps.apple.com/cn/app/zi-wei-dai/id1469767823', anUrl: 'https://www.shmedia.tech/apk/fx.apk'},
   
    {name: '上海普陀', id: '310107', downUrl: 'https://www.shmedia.tech/ptapp/', logo: 'https://assets.shmedia.tech/icon/pt.png', url: 'putuo-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/pt.png', iosUrl: 'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E6%99%AE%E9%99%80/id1439034227', anUrl: 'https://www.shmedia.tech/apk/pt.apk'},
    
    {name: '浦东', id: '310115', downUrl: '', logo: '', url: 'pudong-gateway.shmedia.tech'},
   
    {name: '今日闵行', id: '310112', downUrl: '', url: 'minhang-gateway.shmedia.tech', logo: './icon/minhang.png', background: './backimg/shareBackgroud.png', iosUrl: 'https://apps.apple.com/cn/app/%E4%BB%8A%E6%97%A5%E9%97%B5%E8%A1%8C/id1476809729?appdownload', anUrl:'https://www.shmedia.tech/apk/mh.apk?appdownload'},
    
    {name: '上海静安', id: '310106', downUrl: 'https://www.shmedia.tech/jaapp/', logo: 'https://assets.shmedia.tech/icon/ja.png', url: 'jingan-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/ja.jpg', iosUrl: 'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E9%9D%99%E5%AE%89/id859137971', anUrl:'https://www.shmedia.tech/apk/ja.apk'},
   
    {name: '宝山汇', id: '310113', downUrl: 'https://www.shmedia.tech/bsapp/', logo: 'https://assets.shmedia.tech/icon/bs.png', url: 'baoshan-gateway.shmedia.tech', background: 'https://assets.shmedia.tech/share/backgroundImages/bs.png', iosUrl: 'https://apps.apple.com/cn/app/%E5%AE%9D%E5%B1%B1%E6%B1%87/id1476961748', anUrl:'https://www.shmedia.tech/apk/bs.apk'},
   
    {name: '金山', id: '310116', downUrl: 'https://www.shmedia.tech/jsapp/', logo: 'https://assets.shmedia.tech/icon/js.png', url: 'jinshan-gateway.shmedia.tech',background:'https://assets.shmedia.tech/share/backgroundImages/js.png',iosUrl:'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E9%87%91%E5%B1%B1/id1469670244?l=zh&ls=1',anUrl:'https://www.shmedia.tech/apk/js.apk'},
    
    {name: '不容易', id: '100000', downUrl: 'https://www.shmedia.tech/yysc/', logo: 'https://assets.shmedia.tech/icon/burongyi.png', url: 'bry', background: 'https://assets.shmedia.tech/share/backgroundImages/shareBackgroud.png', iosUrl: '', anUrl: ''},
    {name: '遂溪', id: '440823', downUrl: '', logo: '', url: 'suixi-gateway.shmedia.tech'},
    {name: '徐闻', id: '440825', downUrl: '', logo: '', url: 'xuwen-gateway.shmedia.tech'},
    {name: '雷州', id: '440882', downUrl: '', logo: '', url: 'leizhou-gateway.shmedia.tech'},
    {name: '信宜', id: '440983', downUrl: '', logo: '', url: 'xinyi-gateway.shmedia.tech'},
    {name: '阳西', id: '441721', downUrl: '', logo: '', url: 'yangxi-gateway.shmedia.tech'},

    {name: '今日城区', id: '441500', downUrl: '', url: 'https://swweb.gdmedia.tech', 
    logo: 'https://swweb.gdmedia.tech/h5/sw/share/backimg/jrcq.jpg', background: './backimg/shareBackgroud.png',
    iosUrl: 'https://apps.apple.com/cn/app/id1564689567', 
    anUrl:'https://appgallery.huawei.com/app/C104261407'},
 
]
let siteId = document.getElementById("site").getAttribute("data-site-id")
let site = {
    downUrl: 'https://www.shmedia.tech/' ,
    appIosUrl: '',
    appAnUrl: '',
    siteName: document.getElementById("site").getAttribute("data-site-name"),
    logo: './icon/hongkou.png'
 }
 const appInfo = {
    xh:{
        scheme:'rmtxuhui',
        appstore:'https://itunes.apple.com/cn/app/zi-wei-dai/id1462875484?mt=8',
        backUrl:'https://www.shmedia.tech/apk/xh.apk',
    },
    ja:{
        scheme:'rmtjingan',
        appstore:'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E9%9D%99%E5%AE%89/id859137971',
        backUrl:'https://www.shmedia.tech/apk/ja.apk',
    },
    yp:{
        scheme:'rmtyangpu',
        appstore:'https://itunes.apple.com/cn/app/zi-wei-dai/id1465447632?mt=8',
        backUrl:'https://www.shmedia.tech/apk/yp.apk',
    },
    jd:{
        scheme:'rmtjiading',
        appstore:'https://itunes.apple.com/cn/app/zi-wei-dai/id1465447632?mt=8',
        backUrl:'https://www.shmedia.tech/apk/yp.apk',
    },
    qp:{
        scheme:'rmtqingpu',
        appstore:'https://itunes.apple.com/cn/app/zi-wei-dai/id1469767891?mt=8',
        backUrl:'https://www.shmedia.tech/apk/qp.apk',
    },
    hk:{
        scheme:'rmthongkou',
        appstore:'https://itunes.apple.com/cn/app/zi-wei-dai/id1465446765?mt=8',
        backUrl:'https://www.shmedia.tech/apk/hk.apk',
    },
    hp:{
        scheme:'rmthuangpu',
        appstore:'',
        backUrl:'https://www.shmedia.tech/apk/hp.apk',
    },
    cn:{
        scheme:'rmtchangning',
        appstore:'https://apps.apple.com/cn/app/%E9%95%BF%E5%AE%81%E6%96%B0%E9%97%BB/id1329895656',
        backUrl:'https://www.shmedia.tech/apk/cn.apk',
    },
    fx:{
        scheme:'rmtfengxian',
        appstore:'https://apps.apple.com/cn/app/zi-wei-dai/id1469767823',
        backUrl:'https://www.shmedia.tech/apk/fx.apk',
    },
    pt:{
        scheme:'rmtputuo',
        appstore:'https://apps.apple.com/cn/app/%E4%B8%8A%E6%B5%B7%E6%99%AE%E9%99%80/id1439034227',
        backUrl:'https://www.shmedia.tech/apk/pt.apk'
    },
    mh:{
        scheme:'rmtminhang',
        appstore:'https://apps.apple.com/cn/app/%E4%BB%8A%E6%97%A5%E9%97%B5%E8%A1%8C/id1476809729?appdownload',
        backUrl:'https://www.shmedia.tech/apk/mh.apk?appdownload'
    },
    bs:{
        scheme:'rmtbaoshan',
        appstore:'https://apps.apple.com/cn/app/%E5%AE%9D%E5%B1%B1%E6%B1%87/id1476961748',
        backUrl:'https://www.shmedia.tech/apk/bs.apk'
    },
    cm:{
        scheme:'rmtchangming',
        appstore:'',
        backUrl:'https://www.shmedia.tech/apk/cm.apk'
    }
 }
 console.log('appInfo',appInfo)

function judgeSite() {
    if(!siteId) {
        let contentUrl = location.href
        siteList.forEach(e =>{
            if(contentUrl.indexOf(e.url) > -1) {
                site.downUrl = e.downUrl || 'https://www.shmedia.tech/'
                site.siteName = e.name
                site.logo = e.logo || 'http://hongkou.wditdocker.com/assets/image/ico.png'
                siteId = e.id
                site.appIosUrl = 'rmt' + e.url.split('-')[0] + ':'
                site.appAnUrl = 'rmt' + e.url.split('-')[0] + ':'
                site.iosUrl = e.iosUrl
                site.anUrl = e.anUrl
                site.background = e.background || './backimg/shareBackgroud.png'
            } else {
                siteId = '310109'
            }
        })
    } else {
        siteList.forEach(e =>{
            if(siteId.indexOf(e.id) > -1) {
                site.downUrl = e.downUrl
                site.siteName = e.name
                site.logo = e.logo
                site.iosUrl = e.iosUrl
                site.anUrl = e.anUrl
                site.appIosUrl = 'rmt' + e.url.split('-')[0] + ':'
                site.appAnUrl = 'rmt' + e.url.split('-')[0] + ':'
                site.background = e.background || './backimg/shareBackgroud.png'
            }
        })
    }
}
judgeSite()

axios.defaults.headers.common['siteId'] =   siteId  || '18'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// 封装axios post
const  post = function(url, params) {
    return new Promise((resolve, reject) => {
         axios.post(url, params)
        .then(res => {
            resolve(res)
        })
        .catch(err =>{
            reject(err)
        })
    });
}
// 封装axios get
const  get =  function(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params        
        }).then(res => {
            resolve(res);
        }).catch(err =>{
            reject(err)        
        })    
    });
}
// 获取url参数
function getParams() {
    return new Promise((resolve) =>{
        let obj = {}
        let param = window.location.search
        if(!param) {
           resolve(obj)
        } else {
            let arr = param.slice(1, param.length).split('&')
            arr.forEach(function(val){
                let arr1 = val.split('=');
                obj[arr1[0]] = arr1[1];
            })
            resolve(obj)
        }
        
    })
}
// 动态加载js
function loadScript(src, charset, defer) {
    return new Promise(function(resolve) {
        let script = document.createElement('script');
        script.src = src;
        charset && (script.charset = charset);
        defer && (script.defer = 'defer');
        script.onload = function() {
            resolve();
        };
        (document.head || document.body).appendChild(script);
    });
}
// 动态加载css
function loadCss(src) {
    if(!window.monaco){
        let link = document.createElement('link');
        link.href = src;
        (document.head || document.body).appendChild(link);
    }
}
// 判断是否端内   
let isapp = false   
if(navigator.userAgent.indexOf("RongMeiApp") > -1) {
   isapp = true
}
// let online = location.href.indexOf('shmedia.tech') > -1 
let apiUrl = {
    content: '/media-basic-port/api/app/news/content/get', // {"id": "id" }
    channel: '/media-basic-port/api/app/news/channel/get', // {"id": "subject/0003" }
    channelList: '/media-basic-port/api/app/news/content/list', // {"pageNo": 1,"pageSize": 3,"channel": {"id": "subject/0003"} }
    circle: '/media-basic-port/api/app/moment/status/get',
}
// if(online) {
//     apiUrl.content = '/media-basic-port/api/app/news/content/get'
// }
let isWeixin = {
    in: false,
    show: false
}
// 打开app或下载
function openAppOrDownApp(appUrl, dowmUrl) {
    // 唤起app
    window.location.href = appUrl
    setTimeout(() =>{
      let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden 
      if(typeof hidden == "undefined" || hidden == false){
          // App store下载地址
          window.location.href = dowmUrl
      }
    }, 3000);
}
// 节流函数
let timer = null
function jieliuhanshu(fn, time = 3000) {
    return (function(){
        const context = this
        const args = arguments
        if(!timer){
            timer = setTimeout(function(){
                fn.apply(context, args)
                timer = null
            }, time)
        }
    })()
}
export { post ,  get , getParams, loadScript, loadCss, isapp, apiUrl, site, isWeixin, openAppOrDownApp, jieliuhanshu}

